import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TranslateButtonProps {
  onClick: () => void;
  isTranslating?: boolean;
  disabled?: boolean;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

export const TranslateButton = ({
  onClick,
  isTranslating = false,
  disabled = false,
  className,
  size = 'icon',
}: TranslateButtonProps) => {
  return (
    <Button
      type="button"
      variant="ghost"
      size={size}
      onClick={onClick}
      disabled={disabled || isTranslating}
      className={cn('h-6 w-6 p-0', className)}
      title={isTranslating ? 'Translating...' : 'Auto-translate to Spanish'}
    >
      {isTranslating ? (
        <Loader2 className="h-4 w-4 animate-spin text-blue-600" />
      ) : (
        <span className="text-base">💎</span>
      )}
    </Button>
  );
};
